import {
  AbstractControl,
  ControlValueAccessor as NgControlValueAccessor,
  FormArray,
  FormControl,
  FormGroup,
  NgControl,
} from '@angular/forms';

export interface ControlValueAccessor<T> extends NgControlValueAccessor {
  writeValue(value: T): void;

  registerOnChange(fn: (value: T) => unknown): void;

  registerOnTouched(fn: () => unknown): void;

  setDisabledState?(disabled: boolean): void;
}

declare type NonUndefined<T> = T extends undefined ? never : T;

export declare type ControlsOf<T extends Record<string, any>> = { // eslint-disable-line @typescript-eslint/no-explicit-any
  [K in keyof T]: NonUndefined<T[K]> extends AbstractControl
    ? T[K]
    : NonUndefined<T[K]> extends (infer R extends AbstractControl)[]
      ? FormArray<R>
      : NonUndefined<T[K]> extends Record<any, any> // eslint-disable-line @typescript-eslint/no-explicit-any
        ? FormGroup<ControlsOf<T[K]>>
        : FormControl<T[K]>;
};

export const NOOP_VALUE_ACCESSOR: ControlValueAccessor<never> = {
  writeValue: () => undefined,
  registerOnChange: () => undefined,
  registerOnTouched: () => undefined,
};

export type Control<TControl extends AbstractControl> = Omit<NgControl, 'control' | 'valueAccessor'> & {
  readonly control: TControl;
  valueAccessor: ControlValueAccessor<TControl['value']>;
};
